import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Modal as CoreModal } from '@vds-core/modals';
import { colors } from '@vds-core/theme';

var Modal = function Modal(props) {
  return /*#__PURE__*/React.createElement(CoreModal, _extends({}, props, {
    customScroll: false,
    colorConfig: colors,
    preventBackButton: false,
    fixedCloseButton: false,
    fullScreenDialog: false,
    styleConfig: undefined,
    animationDistance: -150
  }));
};

export default Modal;